import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import detector from 'i18next-browser-languagedetector'

// Translations
import translations from './locales/translations'

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    en: {
        translation: translations.en,
    },
    fr: {
        translation: translations.fr,
    },
    ja: {
        translation: translations.ja,
    },
    de: {
        translation: translations.de,
    },
    nb: {
        translation: translations.nb,
    },
}

i18n.use(detector)
    .use(initReactI18next)
    .init({
        resources,
        supportedLngs: ['fr', 'en', 'ja', 'de', 'nb'],
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    })

export default i18n
